import { launchKeno } from 'services/api/kenoService';
import { ProviderGame } from './ProviderGame';

// Keno, from our Keno provider (repo tottalo-keno). It keeps its own ticket
// inside the game on every layout.
export const Keno = () => (
  <ProviderGame
    launch={launchKeno}
    title="Keno"
    labelKey="keno_label"
    unavailableKey="keno_unavailable"
  />
);
